<template>
	<div class="row trans-row" :class="{last: last}" @click="onSelect">
		<div class="pr0">
			<div class="pull-left">
				<img :src="ic_bank" style="margin: 10px 10px 10px 0"/>
			</div>	
			<div class="pull-left">
				<p>{{ item.bank_address }}</p>
				<p>{{ accountPretty }}</p>
			</div>
		</div>
		<div class="pl0 arrow">
			<span class="ic-arrow" v-if="showArrow"></span>
		</div>	
	</div>
</template>

<script>
import icbc from '@/assets/bank/icbc.png'
import ccb from '@/assets/bank/ccb_pay.png'
import jtbank from '@/assets/bank/jtbank.png'
import cmbc from '@/assets/bank/cmbc.png'
import nybank from '@/assets/bank/nybank.png'
import pfbank from '@/assets/bank/pfbank.png'
import qlbank from '@/assets/bank/qlbank.png'
import cmb from '@/assets/bank/cmb.png'
import weixin from '@/assets/bank/weixin_pay.png'
import alipay from '@/assets/bank/ali_pay.png'

export default {
	name: 'TransAccountRow',
	props: ['item', 'last'],
	data: () => ({
		bankIcons: {
			icbc: icbc,
			ccb_pay: ccb,
			cmbc: cmbc,
			cmb: cmb,
			weixin_pay: weixin,
			ali_pay: alipay,
			allin_pay: alipay,
			jt: jtbank,
			abc: nybank,
			pf: pfbank,
			ql: qlbank,
			bj_icbc: icbc,
			bj_abc: nybank,
			bj_ccb: ccb,
			sd_ccb: ccb,
			sd_abc: nybank,
			sd_weixin: weixin,
			sd_alipay: alipay
		},
		'showArrow': true
	}),
	computed: {
		accountPretty () {
			if (this.item.weixin || this.item.alipay) {
				return this.item.bank_account
			}
			let str = this.item.bank_account || ''
			str = str.split(/(\d{4})/)
			return str.join(' ')
		},
		ic_bank () {
			return this.bankIcons[this.item.short_code]
		}
	},
	components: {
	},
	mounted: function () {
		this.showArrow = this.$route.name === 'TransAccounts'
	},
	methods: {
		onSelect () {
			if (this.$route.name === 'TransAccountsHelp') {
				return
			}
			this.$store.dispatch('setTxAccount', {'txAccount': this.item})
			this.$router.push('/trans/fillin')
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// TransAccountRow.vue?ecd35fb6